<div class="stats" [ngClass]="{ 'highlight-stats': variant === 'highlight' }">
  <div class="stats_content_dynamic">
    @for (stat of stats; track $index) {
      <div class="stats_details">
        <div class="stats_title">{{stat.displayLabel}}</div>
        <div class="stats_desc">
          <div class="icon_container">
            <app-svg-icon [path]="stat?.iconUrl" class="icon"></app-svg-icon>
          </div>
          <span>{{ formatData(stat?.value, stat?.dataType) || "-" }}</span>
        </div>
      </div>
    }
  </div>
</div>

